(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[841,6136,152],{

/***/ 91599:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facetime",
      function () {
        return __webpack_require__(75469);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 66136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SettingsConsumer": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "SettingsContext": function() { return /* binding */ SettingsContext; },
/* harmony export */   "SettingsProvider": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30152);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        ;
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 51514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66136);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__.SettingsContext);


/***/ }),

/***/ 59882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oS": function() { return /* binding */ formatDateToMonthShort; }
/* harmony export */ });
/* unused harmony exports formatDate, formatCreditCardNumber, formatExpirationDate, formatCVC */
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */ // ** Checks if the passed date is today
const isToday = (date)=>{
    const today = new Date();
    return new Date(date).getDate() === today.getDate() && new Date(date).getMonth() === today.getMonth() && new Date(date).getFullYear() === today.getFullYear();
};
const formatDate = function(value) {
    let formatting = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        month: "short",
        day: "numeric",
        year: "numeric"
    };
    if (!value) return value;
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ** Returns short month of passed date
const formatDateToMonthShort = function(value) {
    let toTimeForCurrentDay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    const date = new Date(value);
    let formatting = {
        month: "short",
        day: "numeric"
    };
    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {
            hour: "numeric",
            minute: "numeric"
        };
    }
    return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};
// ? The following functions are taken from https://codesandbox.io/s/ovvwzkzry9?file=/utils.js for formatting credit card details
// Get only numbers from the input value
const clearNumber = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return value.replace(/\D+/g, "");
};
// Format credit cards according to their types
const formatCreditCardNumber = (value, Payment)=>{
    if (!value) {
        return value;
    }
    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;
    switch(issuer){
        case "amex":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 15));
            break;
        case "dinersclub":
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 10), " ").concat(clearValue.slice(10, 14));
            break;
        default:
            nextValue = "".concat(clearValue.slice(0, 4), " ").concat(clearValue.slice(4, 8), " ").concat(clearValue.slice(8, 12), " ").concat(clearValue.slice(12, 19));
            break;
    }
    return nextValue.trim();
};
// Format expiration date in any credit card
const formatExpirationDate = (value)=>{
    const finalValue = value.replace(/^([1-9]\/|[2-9])$/g, "0$1/") // 3 > 03/
    .replace(/^(0[1-9]|1[0-2])$/g, "$1/") // 11 > 11/
    .replace(/^([0-1])([3-9])$/g, "0$1/$2") // 13 > 01/3
    .replace(/^(0?[1-9]|1[0-2])([0-9]{2})$/g, "$1/$2") // 141 > 01/41
    .replace(/^([0]+)\/|[0]+$/g, "0") // 0/ > 0 and 00 > 0
    // To allow only digits and `/`
    .replace(/[^\d\/]|^[\/]*$/g, "").replace(/\/\//g, "/") // Prevent entering more than 1 `/`
    ;
    return finalValue;
};
// Format CVC in any credit card
const formatCVC = (value, cardNumber, Payment)=>{
    const clearValue = clearNumber(value);
    const issuer = Payment.fns.cardType(cardNumber);
    const maxLength = issuer === "amex" ? 4 : 3;
    return clearValue.slice(0, maxLength);
};


/***/ }),

/***/ 83552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
// ** Returns initials from string
const getInitials = (string)=>string.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "");


/***/ }),

/***/ 96665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);




const NoData = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [text, setText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [text2, setText2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [hrefText, setHrefText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const path = window.location.pathname;
        if (path.indexOf("android") != -1) {
            if (path.indexOf("android/local") != -1) {
                setText(t("If there is no data for only some of the features please go to the"));
                setText2(t("page to check Also the app cant track social media data before connection so please be patient if the app is fully authorized"));
                setHrefText(t("Permission check"));
                setHref("".concat("https://test-ms-dashboard.gbyte.com.cn", "/android/local/permission-check"));
                ;
            } else {
                setText(t("Please enable Google backup See"));
                setText2(t("for details"));
                setHrefText(t("here"));
            // if (locale && locale != 'en') {
            //   setHref(
            //     '/guide/back-up-android' + '-' + (locale == 'it-ch' ? 'it' : locale)
            //   )
            // } else {
            //   setHref('/guide/back-up-android')
            // }
            }
        } else {
            setText(t("Please enable iCloud backup See"));
            setText2(t("for details"));
            setHrefText(t("here"));
        // if (locale && locale != 'en') {
        //   setHref('/guide/back-up-ios' + '-' + (locale == 'it-ch' ? 'it' : locale))
        // } else {
        //   setHref('/guide/back-up-ios')
        // }
        }
    }, [
        locale,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "!h-[calc(var(--vh2)*100-240px)] smj:!h-[calc(var(--vh2)*100-115px)] w-full mt-5 [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-2",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 30152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ const themeConfig = {
    // ** Layout Configs
    templateName: "Msafely" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "light" /* light | dark | semi-dark /*! Note: semi-dark value will only work for Vertical Layout */ ,
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: false,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 300 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: false,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["default"] = (themeConfig);


/***/ }),

/***/ 9644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useExtremeFeatureAccessGate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66017);




/**
 * Extreme 功能页门控（仅 iOS-Cloud 有基础/高级绑定）
 *
 * - 未绑定高级：跳转 /ios/extreme-verification
 * - 已绑未购：出升级弹窗
 * - resetTime 未就绪：gatePending
 */ function useExtremeFeatureAccessGate(hasExtremePlan) {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const resetTime = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.resetTime);
    const currentMode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.currentMode);
    const deviceSwitchRevision = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.deviceSwitchRevision);
    const isIos = (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .shouldApplyIosExtremeBindGate */ .yI)(currentMode);
    const resetTimePending = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isResetTimePending */ .z6)(resetTime);
    const advancedNotBound = isIos && (0,src_utils_iosIcloudBindStatus__WEBPACK_IMPORTED_MODULE_3__/* .isAdvancedVerificationIncomplete */ .dU)(resetTime);
    const extremePlan = hasExtremePlan === true || hasExtremePlan === "true";
    const gatePending = resetTimePending;
    const needsExtremeBindPage = isIos && !gatePending && advancedNotBound;
    const showUpgradeModal = isIos && !gatePending && !advancedNotBound && !extremePlan;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!needsExtremeBindPage) return;
        if (router.pathname === "/ios/extreme-verification") return;
        router.replace("/ios/extreme-verification");
    }, [
        needsExtremeBindPage,
        router,
        deviceSwitchRevision
    ]);
    return {
        resetTimePending,
        gatePending,
        advancedNotOver: advancedNotBound,
        needsExtremeBindPage,
        showUpgradeModal
    };
}


/***/ }),

/***/ 57921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useExtremeUpgradeRefresh; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76919);


/**
 * 订阅 Extreme 升级成功事件，刷新「当前所在功能页」的数据与 advanced 状态。
 *
 * 使用场景：页面内嵌了 ExtremeModal，用户在不离开页面的情况下完成升级后，
 * 需要去掉模糊遮罩并重新请求本页接口（如 smsChat-summary / getAllDashboard 等）。
 *
 * 刷新顺序（与 spyx / 后端缓存策略对齐）：
 * 1. notifyExtremeUpgraded 内已 await USER_SUMMARY 预缓冲（触发后台 advanced 同步）
 * 2. 本 hook 再 await primeExtremeAdvancedCache（二次预热，读到同步后的 advanced）
 * 3. 再执行 onUpgraded → 本页业务详情接口，用返回的 advanced 解锁 UI
 *
 * 注意：
 * - onUpgraded 内应复用「设备切换」时的重置 + 拉数逻辑（与 useDeviceScopedInit 保持一致）
 * - 建议先 setAdvanced(true) 乐观解锁 UI，再 dispatch 拉真实数据
 * - onUpgraded 可为 async；须 useCallback 包裹，避免重复注册监听
 *
 * @param {() => void | Promise<void>} onUpgraded - 升级成功后的刷新回调
 *
 * @example
 * useExtremeUpgradeRefresh(
 *   useCallback(() => {
 *     setAdvanced(true)
 *     dispatch(fetchUserProfile()) // hook 内已先 USER_SUMMARY，再执行此处
 *   }, [dispatch])
 * )
 */ function useExtremeUpgradeRefresh(onUpgraded) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!onUpgraded) return;
        const handler = async ()=>{
            await (0,src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .primeExtremeAdvancedCache */ .ti)();
            await Promise.resolve(onUpgraded());
        };
        window.addEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
        return ()=>window.removeEventListener(src_constants_extremeUpgrade__WEBPACK_IMPORTED_MODULE_1__/* .EXTREME_UPGRADED_EVENT */ .zp, handler);
    }, [
        onUpgraded
    ]);
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useExtremeUpgradeRefresh)));


/***/ }),

/***/ 75469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useExtremeUpgradeRefresh__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57921);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5616);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(61730);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29140);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51514);
/* harmony import */ var src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(83552);
/* harmony import */ var src_core_utils_format__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(59882);
/* harmony import */ var src_core_components_telegram_telegram_side_bar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10886);
/* harmony import */ var src_core_components_telegram_telegram_content__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45733);
/* harmony import */ var src_core_components_telegram_telegram_contacts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34245);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95629);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34745);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90948);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33185);
/* harmony import */ var src_core_components_modal_extreme_upgrade__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3769);
/* harmony import */ var src_hooks_useExtremeFeatureAccessGate__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9644);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53399);
// ** React Imports






dayjs__WEBPACK_IMPORTED_MODULE_4___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_5___default()));
// ** MUI Imports



// ** Store & Actions Imports


// ** Hooks

// ** Utils Imports


// ** Chat App Components Imports












const ScrollDiv = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP)("div")({
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const Facetime = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Telegram);
    const storeCommon = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Common);
    // ** States
    const [userStatus, setUserStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("online");
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [userProfileLeftOpen, setUserProfileLeftOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [userProfileRightOpen, setUserProfileRightOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [advanced, setAdvanced] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) // 是否购买高级服务
    ;
    const [fetchLoading, setFetchLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) // 数据获取中
    ;
    const basicNotOver = [
        null,
        ""
    ].includes(storeCommon.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
    ;
    const advancedNotOver = [
        null,
        ""
    ].includes(storeCommon.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
    ;
    // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
    const { gatePending , showUpgradeModal  } = (0,src_hooks_useExtremeFeatureAccessGate__WEBPACK_IMPORTED_MODULE_17__/* .useExtremeFeatureAccessGate */ .t)(advanced);
    const [justVerified, setJustVerified] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否为刚完成验证
    ;
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)();
    const { settings  } = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__/* .useSettings */ .r)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    const hidden = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(theme.breakpoints.down("lg"));
    // ** Vars
    const { skin  } = settings;
    const smAbove = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(theme.breakpoints.up("sm"));
    const sidebarWidth = smAbove ? 370 : 300;
    const mdAbove = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(theme.breakpoints.up("md"));
    const [chat, setChat] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [headImg, setHaedImg] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("/images/telegram/2.jpg");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .fetchUserProfile */ .YI)());
        dispatch((0,src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .fetchChatsContacts */ .Pu)());
    }, [
        dispatch
    ]);
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen((prev)=>!prev);
    const handleUserProfileLeftSidebarToggle = ()=>setUserProfileLeftOpen((prev)=>!prev);
    const handleUserProfileRightSidebarToggle = ()=>setUserProfileRightOpen((prev)=>!prev);
    const [switchDataType, setSwitchDataType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("call");
    const [chatCallData, setChatCallData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [allCallData, setAllCallData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [currentState, setCurrentState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("all");
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) //正在加载获取数据
    ;
    // 分页参数
    const [pagination, setPagination] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        reqNum: 50,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
    const getChatCallData = async (nowOffset)=>{
        // 获取最近的10笔订单
        let res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_18__.getUserAccountOrder)({
            page: 1,
            pageSize: 10
        });
        // 查找有限期最长的订单
        const lastOrder = res.data.sort((a, b)=>dayjs__WEBPACK_IMPORTED_MODULE_4___default()(b.expire_time).valueOf() - dayjs__WEBPACK_IMPORTED_MODULE_4___default()(a.expire_time).valueOf())[0];
        // 计算是否为增值服务上线前付费用户
        // 增值服务上线前付费用户状态更新
        let data = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_12__/* .getAllDashboard */ .gP)({
            username,
            params: {
                category: "FACETIME_INTERACTION",
                offset: nowOffset,
                limit: pagination.reqNum,
                deviceUdid: JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["Unique Identifier"] : ""
            }
        });
        setIsLoading(false);
        const advanced = username == null || !("advanced" in data) || [
            "true",
            true
        ].includes(data === null || data === void 0 ? void 0 : data.advanced) // 高级服务开通状态
        ;
        setAdvanced(advanced);
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_15__/* .changeExtremeService */ .xU)(advanced)) // 更新高级服务状态
        ;
        if (data.data.contents == null) {
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            setFetchLoading(false);
            return;
        }
        let result = data.data.contents.map((row)=>{
            return {
                ...row,
                date: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(row.date).format("YYYY-MM-DD HH:mm:ss"),
                call: row.isFromMe ? "mdi:phone-outgoing" : "ic:round-phone-callback",
                color: row.isFromMe ? "#000" : "#D43538"
            };
        });
        if (!advanced) result = (0,src_utils__WEBPACK_IMPORTED_MODULE_22__/* .generateMockData */ .W)(result);
        setChatCallData((old)=>[
                ...old,
                ...result
            ]);
        setAllCallData((old)=>[
                ...old,
                ...result
            ]);
        setFetchLoading(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const nowOffset = 0;
        getChatCallData(nowOffset);
    }, []);
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 滚动百分比
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
    (0,src_hooks_useExtremeUpgradeRefresh__WEBPACK_IMPORTED_MODULE_2__/* .useExtremeUpgradeRefresh */ .v)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setAdvanced(true);
        setChatCallData([]);
        setAllCallData([]);
        setPagination({
            reqNum: 50,
            nowOffset: 0,
            maxNum: false
        });
        setScroll(0);
        setFetchLoading(true);
        getChatCallData(0);
    }, []));
    // 获取滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = scrollTop / (scrollHeight - clientHeight) * 100;
                setScroll(progress.toFixed(0));
            }
        };
        const currentRef = dom.current;
        if (currentRef) {
            currentRef.addEventListener("scroll", handScroll);
        }
        return ()=>{
            if (currentRef) {
                currentRef.removeEventListener("scroll", handScroll);
            }
        };
    }, []);
    // 监听滚动百分比
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100 && advanced) {
            const nowOffset = pagination.nowOffset + pagination.reqNum;
            setPagination((page)=>({
                    ...page,
                    nowOffset
                }));
            if (!pagination.maxNum) getChatCallData(nowOffset);
        }
    }, [
        scroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Facetime");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_15__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_15__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch
    ]);
    const getStateData = ()=>{
        let newData = [];
        switch(currentState){
            case "missed":
                newData = allCallData.filter((item)=>item.originated === 0 && item.duration === 0);
                setChatCallData([
                    ...newData
                ]);
                break;
            case "outgoing":
                newData = allCallData.filter((item)=>item.isFromMe);
                setChatCallData([
                    ...newData
                ]);
                break;
            case "incoming":
                newData = allCallData.filter((item)=>!item.isFromMe);
                setChatCallData([
                    ...newData
                ]);
                break;
            default:
                setChatCallData([
                    ...allCallData
                ]);
                break;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getStateData();
    }, [
        allCallData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getStateData();
    }, [
        currentState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handelWidth = ()=>{
            if (window.innerWidth > 990) setCurrentState("all");
        };
        handelWidth();
        window.addEventListener("resize", handelWidth);
        return ()=>{
            window.removeEventListener("resize", handelWidth);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_14___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "format-detection",
                    content: "telephone=no"
                })
            }),
            switchDataType == "call" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    !fetchLoading && !gatePending && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: !basicNotOver && !advancedNotOver && !justVerified ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: showUpgradeModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_modal_extreme_upgrade__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                                open: true
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-[144px] Blds:w-[528px] h-[33px] Blds:h-[42px] flex bg-[#EAEAEA] Blds:bg-inherit rounded-[8px] mb-[15px] mx-auto smjs:hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 Blds:flex-auto flex justify-center items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat(currentState === "all" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                                    onClick: ()=>setCurrentState("all"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            src: "/images/facetime/all.svg",
                                            width: 24,
                                            height: 24,
                                            alt: "all call"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                            children: t("All Calls")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 Blds:flex-auto flex justify-center items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat(currentState === "missed" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                                    onClick: ()=>setCurrentState("missed"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            src: "/images/facetime/missed.svg",
                                            width: 24,
                                            height: 24,
                                            alt: "missed"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                            children: t("Missed Calls")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 Blds:flex-auto flex justify-center items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat(currentState === "outgoing" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                                    onClick: ()=>setCurrentState("outgoing"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            src: "/images/facetime/outgoing.svg",
                                            width: 24,
                                            height: 24,
                                            alt: "outgoing"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                            children: t("Outgoing Calls")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 Blds:flex-auto flex justify-center items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat(currentState === "incoming" ? "bg-[#FFF] Blds:bg-[#EAEAEA] drop-shadow-[0_2px_2px_rgba(0,0,0,0.1)] Blds:drop-shadow-none" : "", " w-[30px] Blds:w-auto h-[30px] Blds:h-auto Blds:px-[4px] Blds:py-[9px] flex justify-center items-center rounded-[8px] cursor-pointer"),
                                    onClick: ()=>setCurrentState("incoming"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            src: "/images/facetime/incoming.svg",
                                            width: 24,
                                            height: 24,
                                            alt: "incoming"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[14px] text-[#000] ml-[8px] Bld:hidden",
                                            children: t("Incoming Calls")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ScrollDiv, {
                        ref: dom,
                        className: "bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] Mlg:h-[calc(var(--vh2)*100-139px)] lg:smj:h-[calc(var(--vh2)*100-148px)] smjs:Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] pb-[20px] flex flex-col ".concat(advanced ? "overflow-auto" : "overflow-hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                className: "border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full smj:hidden ".concat(!advanced ? "blur-[16px] select-none" : ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: "sticky top-0 bg-[#FFF]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("DATE")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("DIRECTION")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("DURATION")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("GROUP NAME")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("DISPLAY NAME")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "pt-[10px] text-start text-[14px] text-[#000] font-[600] text-nowrap",
                                                children: t("IDENTIFIER")
                                            })
                                        ]
                                    }),
                                    chatCallData.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.date
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap flex items-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                                        className: "mr-[5px]",
                                                        src: row.isFromMe ? "images/calls/outgoing.svg" : "images/calls/incoming.svg",
                                                        width: 24,
                                                        height: 24,
                                                        alt: row.originated === 0 ? row.duration === 0 ? "missed" : "incoming" : "outgoing"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.duration
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.groupName
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.displayName
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "text-[14px] text-[#000] text-nowrap",
                                                    children: row.identifier
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "smjs:hidden h-auto ".concat(!advanced ? "blur-[16px] select-none" : ""),
                                children: chatCallData.map((row, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "h-[64px] flex w-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-[20px] mt-3 mr-2 ml-[15px]",
                                                children: row.isFromMe && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                                    src: "/images/facetime/outgoing2.svg",
                                                    alt: "outgoing",
                                                    width: 18,
                                                    height: 18
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "border-[#e6e6e6] border-b-[0.5px] w-full flex flex-col justify-center h-[64px] font-[Poppins]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-[16px] font-[500] leading-[24px] ".concat(row.originated === 0 && row.duration === 0 ? " text-[#FE1616]" : " text-[#000000]"),
                                                        children: row.displayName || row.identifier
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-[14px] font-[400] leading-[21px] text-[#8A8A8E]",
                                                                children: dayjs__WEBPACK_IMPORTED_MODULE_4___default().duration(row.duration, "seconds").format("HH:mm:ss")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-[14px] font-[400] text-[#8A8A8E] leading-[21px] mr-[15px]",
                                                                children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(row.date).format("YYYY/MM/DD HH:mm")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            }),
                            advanced && allCallData.length == 0 && !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                                children: [
                                    t("It appears theres no data to show here yet"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    t("If data exists it may take up to 1 hour to download and appear"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    t("We suggest checking back in a little while")
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            switchDataType == "chat" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                className: "app-chat",
                sx: {
                    width: "100%",
                    minHeight: "calc(var(--vh)*100 - 370px)",
                    display: "flex",
                    borderRadius: 1,
                    position: "relative",
                    boxShadow: skin === "bordered" ? 0 : 6,
                    ...skin === "bordered" && {
                        border: "1px solid ".concat(theme.palette.divider)
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_telegram_telegram_side_bar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        userStatus: userStatus,
                        selectMessage: src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .selectMessage */ .rT,
                        getInitials: src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_24__/* .getInitials */ .Q,
                        sidebarWidth: sidebarWidth,
                        setUserStatus: setUserStatus,
                        leftSidebarOpen: leftSidebarOpen,
                        removeSelectedChat: src_store_apps_telegram__WEBPACK_IMPORTED_MODULE_7__/* .removeSelectedChat */ .sr,
                        userProfileLeftOpen: userProfileLeftOpen,
                        formatDateToMonthShort: src_core_utils_format__WEBPACK_IMPORTED_MODULE_25__/* .formatDateToMonthShort */ .oS,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileLeftSidebarToggle: handleUserProfileLeftSidebarToggle,
                        headImg: headImg,
                        setChat: setChat,
                        chat: chat,
                        setHaedImg: setHaedImg
                    }),
                    chat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_telegram_telegram_content__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        getInitials: src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_24__/* .getInitials */ .Q,
                        sidebarWidth: sidebarWidth,
                        userProfileRightOpen: userProfileRightOpen,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                        headImg: headImg,
                        setHaedImg: setHaedImg
                    }),
                    chat === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_telegram_telegram_contacts__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        store: store,
                        hidden: hidden,
                        mdAbove: mdAbove,
                        dispatch: dispatch,
                        getInitials: src_core_utils_get_initials__WEBPACK_IMPORTED_MODULE_24__/* .getInitials */ .Q,
                        sidebarWidth: sidebarWidth,
                        userProfileRightOpen: userProfileRightOpen,
                        handleLeftSidebarToggle: handleLeftSidebarToggle,
                        handleUserProfileRightSidebarToggle: handleUserProfileRightSidebarToggle,
                        headImg: headImg,
                        setHaedImg: setHaedImg
                    }) : ""
                ]
            }) : null
        ]
    });
};
Facetime.contentHeightFixed = true;
/* harmony default export */ __webpack_exports__["default"] = (Facetime);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,518,2862,770,2607,6664,210,8863,1964,6853,7891,1558,9537,5983,3769,1919,9774,2888,179], function() { return __webpack_exec__(91599); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);